import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    BPM_PRODUCT,
    BPM_SUPPLIER,
    BPM_COUNTRY,
    BPM_CATEGORY,
    BPM_LIST,
    BPM_ADD,
    BPM_EDIT,
    BPM_UPLOAD_SET,
    BPM_UPLOAD2_SET
} from "../../actions";

import {
    BPMProductSuccess,
    BPMProductError,
    BPMSupplierSuccess,
    BPMSupplierError,
    BPMCategorySuccess,
    BPMCategoryError,
    BPMCountrySuccess,
    BPMCountryError,
    BPMListSuccess,
    BPMListError,
    BPMAddSuccess,
    BPMAddError,
    BPMEditSuccess,
    BPMEditError,
    BPMUploadSetSuccess,
    BPMUploadSetError,
    BPMUpload2SetSuccess,
    BPMUpload2SetError
} from '../../actions';


export function* watchBPMProduct() {
    yield takeEvery(BPM_PRODUCT, onBPMProduct);
}

export function* watchBPMSupplier() {
    yield takeEvery(BPM_SUPPLIER, onBPMSupplier);
}

export function* watchBPMCategory() {
    yield takeEvery(BPM_CATEGORY, onBPMCategory);
}

export function* watchBPMCountry() {
    yield takeEvery(BPM_COUNTRY, onBPMCountry);
}

export function* watchBPMList() {
    yield takeEvery(BPM_LIST, onBPMList);
}

export function* watchBPMAdd() {
    yield takeEvery(BPM_ADD, onBPMAdd);
}

export function* watchBPMEdit() {
    yield takeEvery(BPM_EDIT, onBPMEdit);
}

export function* watchBPMUploadSet() {
    yield takeEvery(BPM_UPLOAD_SET, onBPMUploadSet);
}

export function* watchBPMUpload2Set() {
    yield takeEvery(BPM_UPLOAD2_SET, onBPMUpload2Set);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onBPMProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMCategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMCountryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/country', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onBPMAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthBPM/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBPMUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/healthBPM/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'healthregistration/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

const onBPMUpload2SetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/healthBPM/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'healthregistration/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onBPMProduct(data) {
    try {
        const response = yield call(onBPMProductAsync, data.payload);
        yield put(BPMProductSuccess(response.data));
    } catch (error) {
        yield put(BPMProductError(error));
    }
}

function* onBPMSupplier(data) {
    try {
        const response = yield call(onBPMSupplierAsync, data.payload);
        yield put(BPMSupplierSuccess(response.data));
    } catch (error) {
        yield put(BPMSupplierError(error));
    }
}

function* onBPMCategory(data) {
    try {
        const response = yield call(onBPMCategoryAsync, data.payload);
        yield put(BPMCategorySuccess(response.data));
    } catch (error) {
        yield put(BPMCategoryError(error));
    }
}

function* onBPMCountry(data) {
    try {
        const response = yield call(onBPMCountryAsync, data.payload);
        yield put(BPMCountrySuccess(response.data));
    } catch (error) {
        yield put(BPMCountryError(error));
    }
}


function* onBPMList(data) {
    try {
        const response = yield call(onBPMListAsync, data.payload);
        yield put(BPMListSuccess(response.data));
    } catch (error) {
        yield put(BPMListError(error));
    }
}

function* onBPMAdd(data) {
    try {
        const response = yield call(onBPMAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(BPMAddSuccess(response.data));
    } catch (error) {
        yield put(BPMAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onBPMEdit(data) {
    try {
        const response = yield call(onBPMEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(BPMEditSuccess(response.data));
    } catch (error) {
        yield put(BPMEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onBPMUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onBPMUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(BPMUploadSetSuccess(response));

        }
        else {
            yield put(BPMUploadSetError(response));
        }
    } catch (error) {
        yield put(BPMUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}


function* onBPMUpload2Set({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onBPMUpload2SetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(BPMUpload2SetSuccess(response));

        }
        else {
            yield put(BPMUpload2SetError(response));
        }
    } catch (error) {
        yield put(BPMUpload2SetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchBPMProduct),
        fork(watchBPMSupplier),
        fork(watchBPMCategory),
        fork(watchBPMCountry),
        fork(watchBPMList),
        fork(watchBPMAdd),
        fork(watchBPMEdit),
        fork(watchBPMUploadSet),
        fork(watchBPMUpload2Set)
    ]);
}